module.exports = __webpack_public_path__ + "img/waiting-checkout.60afeec6.svg";